import { CardName } from './cards/CardName';
// There might be a temptation to rename or reorder these, but TileType is stored in the database
// as its number. Would have been better if this was stored as a string, but that ship has sailed,
// for now.
export var TileType;
(function (TileType) {
    TileType[TileType["GREENERY"] = 0] = "GREENERY";
    TileType[TileType["OCEAN"] = 1] = "OCEAN";
    TileType[TileType["CITY"] = 2] = "CITY";
    TileType[TileType["CAPITAL"] = 3] = "CAPITAL";
    TileType[TileType["COMMERCIAL_DISTRICT"] = 4] = "COMMERCIAL_DISTRICT";
    TileType[TileType["ECOLOGICAL_ZONE"] = 5] = "ECOLOGICAL_ZONE";
    TileType[TileType["INDUSTRIAL_CENTER"] = 6] = "INDUSTRIAL_CENTER";
    TileType[TileType["LAVA_FLOWS"] = 7] = "LAVA_FLOWS";
    TileType[TileType["MINING_AREA"] = 8] = "MINING_AREA";
    TileType[TileType["MINING_RIGHTS"] = 9] = "MINING_RIGHTS";
    TileType[TileType["MOHOLE_AREA"] = 10] = "MOHOLE_AREA";
    TileType[TileType["NATURAL_PRESERVE"] = 11] = "NATURAL_PRESERVE";
    TileType[TileType["NUCLEAR_ZONE"] = 12] = "NUCLEAR_ZONE";
    TileType[TileType["RESTRICTED_AREA"] = 13] = "RESTRICTED_AREA";
    TileType[TileType["DEIMOS_DOWN"] = 14] = "DEIMOS_DOWN";
    TileType[TileType["GREAT_DAM"] = 15] = "GREAT_DAM";
    TileType[TileType["MAGNETIC_FIELD_GENERATORS"] = 16] = "MAGNETIC_FIELD_GENERATORS";
    TileType[TileType["BIOFERTILIZER_FACILITY"] = 17] = "BIOFERTILIZER_FACILITY";
    TileType[TileType["METALLIC_ASTEROID"] = 18] = "METALLIC_ASTEROID";
    TileType[TileType["SOLAR_FARM"] = 19] = "SOLAR_FARM";
    TileType[TileType["OCEAN_CITY"] = 20] = "OCEAN_CITY";
    TileType[TileType["OCEAN_FARM"] = 21] = "OCEAN_FARM";
    TileType[TileType["OCEAN_SANCTUARY"] = 22] = "OCEAN_SANCTUARY";
    TileType[TileType["DUST_STORM_MILD"] = 23] = "DUST_STORM_MILD";
    TileType[TileType["DUST_STORM_SEVERE"] = 24] = "DUST_STORM_SEVERE";
    TileType[TileType["EROSION_MILD"] = 25] = "EROSION_MILD";
    TileType[TileType["EROSION_SEVERE"] = 26] = "EROSION_SEVERE";
    TileType[TileType["MINING_STEEL_BONUS"] = 27] = "MINING_STEEL_BONUS";
    TileType[TileType["MINING_TITANIUM_BONUS"] = 28] = "MINING_TITANIUM_BONUS";
    // The Moon
    TileType[TileType["MOON_MINE"] = 29] = "MOON_MINE";
    TileType[TileType["MOON_HABITAT"] = 30] = "MOON_HABITAT";
    TileType[TileType["MOON_ROAD"] = 31] = "MOON_ROAD";
    TileType[TileType["LUNA_TRADE_STATION"] = 32] = "LUNA_TRADE_STATION";
    TileType[TileType["LUNA_MINING_HUB"] = 33] = "LUNA_MINING_HUB";
    TileType[TileType["LUNA_TRAIN_STATION"] = 34] = "LUNA_TRAIN_STATION";
    TileType[TileType["LUNAR_MINE_URBANIZATION"] = 35] = "LUNAR_MINE_URBANIZATION";
    // Pathfinders
    TileType[TileType["WETLANDS"] = 36] = "WETLANDS";
    TileType[TileType["RED_CITY"] = 37] = "RED_CITY";
    TileType[TileType["_DEPRECATED_MARTIAN_NATURE_WONDERS"] = 38] = "_DEPRECATED_MARTIAN_NATURE_WONDERS";
    TileType[TileType["CRASHLANDING"] = 39] = "CRASHLANDING";
    TileType[TileType["MARS_NOMADS"] = 40] = "MARS_NOMADS";
    TileType[TileType["_DEPRECATED_REY_SKYWALKER"] = 41] = "_DEPRECATED_REY_SKYWALKER";
    // Underworld
    TileType[TileType["MAN_MADE_VOLCANO"] = 42] = "MAN_MADE_VOLCANO";
    // Promo
    TileType[TileType["NEW_HOLLAND"] = 43] = "NEW_HOLLAND";
    // Automa
    TileType[TileType["NEURAL_INSTANCE"] = 44] = "NEURAL_INSTANCE";
    // Sillyfication
    TileType[TileType["GARBAGE_DUMP"] = 45] = "GARBAGE_DUMP";
    // Rob Antilles
    TileType[TileType["PUMPING_HUB"] = 46] = "PUMPING_HUB";
    // idesOfMars
    TileType[TileType["INVAK_CITY"] = 47] = "INVAK_CITY";
    // Rob Antilles
    TileType[TileType["SUBURBS"] = 48] = "SUBURBS";
    TileType[TileType["HARBOR_BOREALIS"] = 49] = "HARBOR_BOREALIS";
    TileType[TileType["INDUSTRIAL_METROPOLIS"] = 50] = "INDUSTRIAL_METROPOLIS";
    TileType[TileType["PARADISE_CITY"] = 51] = "PARADISE_CITY";
    TileType[TileType["ANIMAL_DOME"] = 52] = "ANIMAL_DOME";
    TileType[TileType["SEDIMENT"] = 53] = "SEDIMENT";
    TileType[TileType["BIOLOGICAL_DOME"] = 54] = "BIOLOGICAL_DOME";
    // Venus Phase 2
    TileType[TileType["VENUS_CLOUD_CITY"] = 55] = "VENUS_CLOUD_CITY";
    TileType[TileType["VENUS_GAS_MINE"] = 56] = "VENUS_GAS_MINE";
    TileType[TileType["VENUS_FLOATER_ARRAY"] = 57] = "VENUS_FLOATER_ARRAY";
    // Industries
    TileType[TileType["INDUSTRY_HEAT"] = 58] = "INDUSTRY_HEAT";
    TileType[TileType["INDUSTRY_MONEY"] = 59] = "INDUSTRY_MONEY";
    TileType[TileType["INDUSTRY_ENERGY"] = 60] = "INDUSTRY_ENERGY";
    TileType[TileType["INDUSTRY_STEEL"] = 61] = "INDUSTRY_STEEL";
    TileType[TileType["INDUSTRY_PLANT"] = 62] = "INDUSTRY_PLANT";
    TileType[TileType["INDUSTRY_TITANIUM"] = 63] = "INDUSTRY_TITANIUM";
    TileType[TileType["INDUSTRY_WILD"] = 64] = "INDUSTRY_WILD";
    // Venus Phase 2
    TileType[TileType["MENAGERIE"] = 65] = "MENAGERIE";
})(TileType || (TileType = {}));
export const tileTypeToString = {
    [TileType.GREENERY]: 'greenery',
    [TileType.OCEAN]: 'ocean',
    [TileType.CITY]: 'city',
    [TileType.CAPITAL]: CardName.CAPITAL,
    [TileType.COMMERCIAL_DISTRICT]: CardName.COMMERCIAL_DISTRICT,
    [TileType.ECOLOGICAL_ZONE]: CardName.ECOLOGICAL_ZONE,
    [TileType.INDUSTRIAL_CENTER]: CardName.INDUSTRIAL_CENTER,
    [TileType.LAVA_FLOWS]: CardName.LAVA_FLOWS,
    [TileType.MINING_AREA]: CardName.MINING_AREA,
    [TileType.MINING_RIGHTS]: CardName.MINING_RIGHTS,
    [TileType.MOHOLE_AREA]: CardName.MOHOLE_AREA,
    [TileType.NATURAL_PRESERVE]: CardName.NATURAL_PRESERVE,
    [TileType.NUCLEAR_ZONE]: CardName.NUCLEAR_ZONE,
    [TileType.RESTRICTED_AREA]: CardName.RESTRICTED_AREA,
    [TileType.DEIMOS_DOWN]: CardName.DEIMOS_DOWN,
    [TileType.GREAT_DAM]: CardName.GREAT_DAM,
    [TileType.MAGNETIC_FIELD_GENERATORS]: CardName.MAGNETIC_FIELD_GENERATORS,
    [TileType.BIOFERTILIZER_FACILITY]: CardName.BIOFERTILIZER_FACILITY,
    [TileType.METALLIC_ASTEROID]: CardName.METALLIC_ASTEROID,
    [TileType.SOLAR_FARM]: CardName.SOLAR_FARM,
    [TileType.OCEAN_CITY]: CardName.OCEAN_CITY,
    [TileType.OCEAN_FARM]: CardName.OCEAN_FARM,
    [TileType.OCEAN_SANCTUARY]: CardName.OCEAN_SANCTUARY,
    [TileType.DUST_STORM_MILD]: 'Mild Dust Storm',
    [TileType.DUST_STORM_SEVERE]: 'Severe Dust Storm',
    [TileType.EROSION_MILD]: 'Mild Erosion',
    [TileType.EROSION_SEVERE]: 'Severe Erosion',
    [TileType.MINING_STEEL_BONUS]: 'Mining (Steel)',
    [TileType.MINING_TITANIUM_BONUS]: 'Mining (Titanium)',
    [TileType.MOON_MINE]: 'Mine',
    [TileType.MOON_HABITAT]: 'Habitat',
    [TileType.MOON_ROAD]: 'Road',
    [TileType.LUNA_TRADE_STATION]: CardName.LUNA_TRADE_STATION,
    [TileType.LUNA_MINING_HUB]: CardName.LUNA_MINING_HUB,
    [TileType.LUNA_TRAIN_STATION]: CardName.LUNA_TRAIN_STATION,
    [TileType.LUNAR_MINE_URBANIZATION]: CardName.LUNAR_MINE_URBANIZATION,
    [TileType.WETLANDS]: CardName.WETLANDS,
    [TileType.RED_CITY]: CardName.RED_CITY,
    [TileType._DEPRECATED_MARTIAN_NATURE_WONDERS]: '',
    [TileType.CRASHLANDING]: CardName.CRASHLANDING,
    [TileType.MARS_NOMADS]: CardName.MARS_NOMADS,
    [TileType._DEPRECATED_REY_SKYWALKER]: '',
    [TileType.MAN_MADE_VOLCANO]: CardName.MAN_MADE_VOLCANO,
    [TileType.NEW_HOLLAND]: CardName.NEW_HOLLAND,
    [TileType.NEURAL_INSTANCE]: 'Neural Instance',
    [TileType.GARBAGE_DUMP]: CardName.GARBAGE_DUMPS,
    [TileType.PUMPING_HUB]: CardName.THARSIS_PUMPING_HUB,
    [TileType.INVAK_CITY]: CardName.INVAK_CITY,
    [TileType.SUBURBS]: CardName.SUBURBS,
    [TileType.HARBOR_BOREALIS]: CardName.HARBOR_BOREALIS,
    [TileType.INDUSTRIAL_METROPOLIS]: CardName.INDUSTRIAL_METROPOLIS,
    [TileType.PARADISE_CITY]: CardName.PARADISE_CITY,
    [TileType.ANIMAL_DOME]: CardName.LIVESTOCK_GIANT_DOME,
    [TileType.SEDIMENT]: CardName.SEDIMENTARY_ROCKS,
    [TileType.BIOLOGICAL_DOME]: CardName.MOBILE_BIOLOGICAL_DOME,
    [TileType.VENUS_CLOUD_CITY]: 'Cloud City',
    [TileType.VENUS_GAS_MINE]: 'Gas Mine',
    [TileType.VENUS_FLOATER_ARRAY]: 'Floater Array',
    [TileType.INDUSTRY_HEAT]: CardName.HEAT_INDUSTRY_STANDARD_PROJECT,
    [TileType.INDUSTRY_MONEY]: CardName.MONEY_INDUSTRY_STANDARD_PROJECT,
    [TileType.INDUSTRY_ENERGY]: CardName.ENERGY_INDUSTRY_STANDARD_PROJECT,
    [TileType.INDUSTRY_STEEL]: CardName.STEEL_INDUSTRY_STANDARD_PROJECT,
    [TileType.INDUSTRY_PLANT]: CardName.PLANT_INDUSTRY_STANDARD_PROJECT,
    [TileType.INDUSTRY_TITANIUM]: CardName.TITANIUM_INDUSTRY_STANDARD_PROJECT,
    [TileType.INDUSTRY_WILD]: CardName.WILD_INDUSTRY_STANDARD_PROJECT,
    [TileType.MENAGERIE]: CardName.MENAGERIE,
};
export const HAZARD_TILES = new Set([TileType.DUST_STORM_MILD, TileType.DUST_STORM_SEVERE, TileType.EROSION_MILD, TileType.EROSION_SEVERE]);
// Harbor Borealis (Rob Antilles) is placed over a plain ocean tile, same "upgradeable ocean"
// placement rule as Ocean City/Ocean Farm/Ocean Sanctuary/New Holland. Unlike those, its printed
// text never says it "counts as an ocean", so it's deliberately left out of OCEAN_TILES below.
export const OCEAN_UPGRADE_TILES = new Set([TileType.OCEAN_CITY, TileType.OCEAN_FARM, TileType.OCEAN_SANCTUARY, TileType.NEW_HOLLAND, TileType.HARBOR_BOREALIS]);
// Invak City (idesOfMars) substitutes one of the player's own greeneries and counts as both a
// city and a greenery -- same "counts as two things" pattern as Ocean City/New Holland (ocean +
// city) and Wetlands (ocean + greenery) above. Suburbs and Paradise City (Rob Antilles) are the
// same pattern for "counts as a City" specifically.
export const CITY_TILES = new Set([TileType.CITY, TileType.CAPITAL, TileType.OCEAN_CITY, TileType.RED_CITY, TileType.NEW_HOLLAND, TileType.INVAK_CITY, TileType.SUBURBS, TileType.PARADISE_CITY]);
export const OCEAN_TILES = new Set([TileType.OCEAN, TileType.OCEAN_CITY, TileType.OCEAN_FARM, TileType.OCEAN_SANCTUARY, TileType.WETLANDS, TileType.NEW_HOLLAND]);
export const BASE_OCEAN_TILES = new Set([TileType.OCEAN, TileType.WETLANDS]);
export const GREENERY_TILES = new Set([TileType.GREENERY, TileType.WETLANDS, TileType.INVAK_CITY]);
// Rob Antilles: tiles placed on top of the player's OWN existing greenery/city tile, mirroring
// the ocean-upgrade pattern above but for the other two base tile types. See MarsBoard.canCover.
export const GREENERY_UPGRADE_TILES = new Set([TileType.SUBURBS, TileType.MENAGERIE]);
export const CITY_UPGRADE_TILES = new Set([TileType.INDUSTRIAL_METROPOLIS, TileType.PARADISE_CITY]);
